export default __webpack_public_path__ + "static/hetzner_community_4-1859265a8199266a0c48e25c5dbcb556.jpg";